module.exports = __webpack_public_path__ + "img/step-active.ce8fef84.png";